import { Modal } from "./Modal.js";

/**
 * 快捷键帮助（Shift + ?）。
 * 键盘优先的界面必须有一个「按键说明书」，否则新用户只能靠猜。
 */

export interface ShortcutRow {
  readonly keys: string;
  readonly action: string;
  readonly scope: string;
}

export const SHORTCUTS: readonly ShortcutRow[] = [
  { keys: "⌘K / Ctrl+K", action: "打开命令面板", scope: "全局" },
  { keys: "G 然后 1–4", action: "跳转到：概览 / 表格 / 同步 / 设置", scope: "全局" },
  { keys: "Shift + ?", action: "打开本帮助", scope: "全局" },
  { keys: "Esc", action: "关闭浮层 / 清除选中", scope: "全局" },
  { keys: "↑ / ↓", action: "逐行移动焦点（自动滚动到可见）", scope: "表格" },
  { keys: "PageUp / PageDown", action: "翻 20 行", scope: "表格" },
  { keys: "Home / End", action: "跳到首行 / 末行", scope: "表格" },
  { keys: "Space", action: "切换当前行选中", scope: "表格" },
  { keys: "Shift + ↑/↓", action: "从锚点扩展选中范围（并滚动）", scope: "表格" },
  { keys: "⌘A / Ctrl+A", action: "全选当前筛选结果", scope: "表格" },
  { keys: "Enter", action: "打开当前行详情", scope: "表格" },
  { keys: "← / →", action: "横向滚动 100px", scope: "表格" },
];

export interface ShortcutHelpProps {
  readonly open: boolean;
  readonly onClose: () => void;
}

export function ShortcutHelp({ open, onClose }: ShortcutHelpProps) {
  return (
    <Modal
      open={open}
      title="键盘快捷键"
      description="键盘优先不是可选项：批量操作、筛选、导航都应该不碰鼠标完成。"
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={onClose}
          className="rounded-control bg-accent px-3 text-table font-medium text-accent-ink transition-colors dur-fast hover:bg-accent-hover"
          style={{ height: "var(--control-height)" }}
        >
          知道了
        </button>
      }
    >
      <table className="w-full border-collapse text-table">
        <thead>
          <tr className="border-b border-line-subtle text-left text-meta text-ink-3">
            <th className="py-1 font-medium">按键</th>
            <th className="py-1 font-medium">动作</th>
            <th className="py-1 font-medium">范围</th>
          </tr>
        </thead>
        <tbody>
          {SHORTCUTS.map((row) => (
            <tr key={row.keys} className="border-b border-line-subtle">
              <td className="py-1 pr-3">
                <kbd className="rounded-xs border border-line bg-sunken px-1.5 py-0.5 font-mono text-2xs text-ink">
                  {row.keys}
                </kbd>
              </td>
              <td className="py-1 pr-3 text-ink-2">{row.action}</td>
              <td className="py-1 text-ink-3">{row.scope}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  );
}
